import React from 'react';

import Modal from 'antd/es/modal/Modal';

import { addSubtitlesToYoutubeVideos } from '@app/utils/VideoExtensions';

const ModalVideo = ({
	modalVisible,
	setModalVisible,
	videoSrc,
	getContainer = 'body',
}) => {
	return (
		<Modal
			wrapClassName="modal-wrap modal-wrap-video"
			open={modalVisible}
			onOk={() => setModalVisible(false)}
			onCancel={() => setModalVisible(false)}
			width={859}
			centered
			getContainer={getContainer}
			destroyOnClose
		>
			<div className="modal-video">
				<iframe
					className="video-embed-block__video"
					src={addSubtitlesToYoutubeVideos(videoSrc)}
					width="697"
					height="392"
					allow="autoplay; fullscreen"
					allowFullScreen
					title={videoSrc}
				/>
			</div>
		</Modal>
	);
};

export default ModalVideo;
